// extracted by mini-css-extract-plugin
export default {"popupWrapper":"ProgressPopup_popupWrapper__VPSsX","parentDiv":"ProgressPopup_parentDiv__dW5yu","contentDiv":"ProgressPopup_contentDiv__azc4G","table":"ProgressPopup_table__BUuSq"};